import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { requestResetPassword } from '../api/login';
import { seoDefaults } from "../utils/seoDefaults";
import SEO from "../api/seo";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const { state } = useLocation();
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      toast.error('Passwords do not match');
      return;
    }

    try {
      await requestResetPassword(state.email, newPassword, state.token);
      toast.success('Password updated successfully');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update password');
    }
  };

  return (
    <>
     <SEO {...seoDefaults.resetPassword} />
      <div className="min-h-screen bg-gray-950 text-white flex flex-col justify-center items-center relative overflow-hidden px-4 py-16">
        <div className="absolute top-1/3 left-1/4 w-80 h-80 bg-purple-900/20 rounded-full filter blur-3xl animate-pulse"></div>
        <div className="absolute top-1/2 right-1/4 w-96 h-96 bg-cyan-900/20 rounded-full filter blur-3xl animate-pulse"></div>

        <div className="relative z-10 w-full max-w-md bg-gradient-to-br from-gray-900 to-gray-800 border border-cyan-500 rounded-2xl p-8 shadow-2xl">
          <h2 className="text-3xl font-extrabold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500">
            Reset Password
          </h2>
          <p className="text-center text-sm text-gray-400 mb-6">Enter your new password below</p>

          <form onSubmit={handleReset} className="space-y-5">
            <div>
              <label className="block text-sm mb-1 text-gray-300">New Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                className="w-full p-3 rounded-lg bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-500"
                placeholder="New Password"
              />
            </div>

            <div>
              <label className="block text-sm mb-1 text-gray-300">Confirm Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className="w-full p-3 rounded-lg bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500"
                placeholder="Confirm Password"
              />
            </div>

            {error && <p className="text-red-400 text-sm text-center">{error}</p>}

            <button
              type="submit"
              className="w-full py-3 rounded-lg bg-gradient-to-r from-cyan-500 to-purple-600 text-white font-semibold tracking-wide hover:shadow-lg hover:shadow-cyan-500/30 transition-all"
            >
              Update Password
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
